import React from 'react';

export default () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
        <title> info-tootlip</title>
        <defs>
            <path
                d="M8 16C3.6 16 0 12.4 0 8 0 3.6 3.6 0 8 0 12.4 0 16 3.6 16 8 16 12.4 12.4 16 8 16ZM8.8 10.4L8.8 7.2C8.8 6.8 8.4 6.4 8 6.4L6.4 6.4 6.4 8 7.2 8 7.2 10.4 5.6 10.4 5.6 12 10.4 12 10.4 10.4 8.8 10.4ZM8 5C8.6 5 9 4.6 9 4 9 3.4 8.6 3 8 3 7.4 3 7 3.4 7 4 7 4.6 7.4 5 8 5Z"
                id="path-1"
            />
        </defs>
        <g id="info-tootlip" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Icon/Info-for-Hover">
                <mask id="mask-2" fill="white">
                    <use xlinkHref="#path-1" />
                </mask>
                <g id="Mask" />
                <g id="Color" mask="url(#mask-2)" fill="#3DB7E4">
                    <g transform="translate(-2.000000, -2.000000)" id="Box">
                        <rect x="0" y="0" width="20" height="20" />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);
